import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "BaseItemDialog__section flex-1" }
const _hoisted_2 = { class: "BaseItemDialog__section-header bg-white q-mb-12" }
const _hoisted_3 = { class: "fs-15px fw-600 text-cool-gray-100 block q-mb-sm" }
const _hoisted_4 = { class: "BaseItemDialog__section-body flex column no-wrap gap-12" }
const _hoisted_5 = { class: "q-px-sm q-py-xs flex no-wrap items-center justify-between" }
const _hoisted_6 = { class: "fs-15px text-cool-gray-70" }
const _hoisted_7 = { class: "fs-15px text-cool-gray-100 text-right" }
const _hoisted_8 = { class: "q-px-sm q-py-xs flex no-wrap items-center justify-between" }
const _hoisted_9 = { class: "fs-15px text-cool-gray-70" }
const _hoisted_10 = { class: "fs-15px text-cool-gray-100 text-right" }
const _hoisted_11 = { class: "q-px-sm q-py-xs flex no-wrap items-center justify-between" }
const _hoisted_12 = { class: "fs-15px text-cool-gray-70" }
const _hoisted_13 = { class: "fs-15px text-cool-gray-100 text-right" }

import translate from 'src/common/helpers/language/translate'
import translationObject from '../../../../pages/Inventory/Item/ItemLibrary/translate/itemLibrary.translate'
import globalTranslateObject from 'src/translate/global.translate'
import { IItemView } from 'src/common/interfaces'

interface IProps {
  item: IItemView
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseItemDialogPOS' },
  __name: 'BaseItemDialogPOS',
  props: {
    item: {}
  },
  setup(__props: any) {




const { t } = translate(translationObject)
const { t: globalT } = translate(globalTranslateObject)

return (_ctx: any,_cache: any) => {
  const _component_k_divider = _resolveComponent("k-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('pos.title')), 1 /* TEXT */),
      _createVNode(_component_k_divider, { size: "md" })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('pos.max_order_qty')), 1 /* TEXT */),
        _createElementVNode("span", _hoisted_7, _toDisplayString(Number(__props.item.max_qty_sellable)), 1 /* TEXT */)
      ]),
      _createVNode(_component_k_divider, {
        dotted: true,
        color: "cool-gray-50"
      }),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('pos.minimum_stock_qty_alert')), 1 /* TEXT */),
        _createElementVNode("span", _hoisted_10, _toDisplayString(Number(__props.item.min_alert_qty)), 1 /* TEXT */)
      ]),
      _createVNode(_component_k_divider, {
        dotted: true,
        color: "cool-gray-50"
      }),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(globalT)('daily_available_quantity')), 1 /* TEXT */),
        _createElementVNode("span", _hoisted_13, _toDisplayString(Number(__props.item.daily_qty_available)), 1 /* TEXT */)
      ]),
      _createCommentVNode(" <BaseItemDialogStateIndicator\n        :left=\"{ label: 'Visible in Menu', value: false }\"\n        :right=\"{ label: 'Visible in POS', value: item.show_in_pos }\"\n      /> ")
    ])
  ]))
}
}

})